import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm, stopAsyncValidation } from 'redux-form/immutable'
import { connect } from 'react-redux'

import { addReducer, removeReducer } from 'state/reducers'
import { addSaga, removeSaga } from 'state/sagas'

import Page from 'layouts/Page'
import Masthead, { MastheadOverlap } from 'layouts/Masthead'
import Container from 'layouts/Container'
import { FormFieldset } from 'layouts/Form'
import Box, { BoxSection } from 'layouts/Box'
import Input from 'components/Input'
import Button from 'components/Button'

import { required } from 'utilities/validators'

import { NAME } from './constants'
import reducer from './reducer'
import actions from './actions'
import saga from './sagas'
import selector from './selectors'

import styles from './styles.css'

class PasswordReset extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    asyncValidating: PropTypes.bool,
    token: PropTypes.string,
    userId: PropTypes.string,
    failed: PropTypes.bool,
    submitting: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
  }

  static defaultProps = {
    asyncValidating: false,
    token: null,
    userId: null,
    failed: false,
    submitting: false,
    submitSucceeded: false,
  }

  componentDidMount() {
    addReducer(NAME, reducer)
    addSaga(NAME, saga)
  }

  componentWillUnmount() {
    removeReducer(NAME)
    removeSaga(NAME)
  }

  onSubmit = values =>
    this.props.dispatch(actions.submit({ ...this.props, ...values.toJS() }))

  renderForm() {
    const { userId, token } = this.props

    return (
      <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <FormFieldset>
          {(token &&
            userId && (
              <Field
                component={Input}
                label="Ange lösenord"
                type="password"
                name="password"
                validate={[required]}
              />
            )) || (
            <Field
              component={Input}
              label="Din e-postadress"
              type="email"
              name="email"
              validate={[required]}
            />
          )}
        </FormFieldset>

        <p style={{ textAlign: 'center' }}>
          <Button loading={this.props.asyncValidating} rounded>
            Skicka
          </Button>
        </p>
      </form>
    )
  }

  renderSuccess() {
    const { userId } = this.props

    if (userId) {
      return <p>Ditt lösenord är uppdaterat!</p>
    }
    return (
      <p>
        Tack, ett email har skickats till din mejladress med en länk för att
        återställa lösenordet.
      </p>
    )
  }

  render() {
    const { token, failed, submitting, submitSucceeded } = this.props

    const success = !submitting && submitSucceeded && !failed

    return (
      <Page className={styles.root} title="Skapa nytt lösenord">
        <Masthead overlap>
          <Container size="medium">
            <h1>Skapa nytt lösenord</h1>
            {!token && (
              <p>
                Om du glömt ditt lösenord kan vi skicka dig ett email med en
                länk där du kan fylla i ett nytt.
              </p>
            )}
          </Container>
        </Masthead>

        <MastheadOverlap>
          <Container size="medium">
            <Box shadow>
              <BoxSection>
                {(success && this.renderSuccess()) || this.renderForm()}
              </BoxSection>
            </Box>
          </Container>
        </MastheadOverlap>
      </Page>
    )
  }
}

export default connect(selector)(
  reduxForm({
    form: NAME,
    onChange: (values, dispatch) => {
      dispatch(stopAsyncValidation(NAME, { clear: true }))
    },
  })(PasswordReset),
)



// WEBPACK FOOTER //
// ../source/views/PasswordReset/index.js